import { VERSION, REVISION } from "../consts/version";

function removeEmptyElementsByClass(className) {
  const elements = document.querySelectorAll(`.${className}`);

  elements.forEach(function (element) {
    if (!element.hasChildNodes() || element.innerHTML.trim() === "") {
      element.remove();
    }
  });
}

$(function () {
  //Version set start
  $(".footer-logo").attr("title", `v${VERSION} (${REVISION})`);
  //Version set end

  $("#open_search").on("click", function (e) {
    e.preventDefault();
    $(".header").addClass("is-search-open");
  });

  $("#close_search").on("click", function (e) {
    e.preventDefault();
    $(".header").removeClass("is-search-open");
  });
  $(".search-icon").on("click", function (e) {
    e.preventDefault();
    const searchSection = $(".lazy-load.section-search");
    const beforeHeight = 115;
    if (searchSection.length) {
      $("html, body").animate(
        {
          scrollTop: searchSection.offset().top - beforeHeight,
        },
        "fast"
      );
    }
  });

  $(".search form").on("submit", function (e) {
    if (!$(this).find(".search__field").val().replace(/\s/g, "").length) {
      e.preventDefault();
    }
  });
});

jQuery(document).ready(function () {
  removeEmptyElementsByClass("sidebar-widget");
  $(".wpml-ls-current-language").remove();

  if ($(".translation-post .change-language").length > 0) {
    $(".translation-post .change-language").attr(
      "href",
      $(".translation-post .wpml-ls a").attr("href")
    );
    $(".translation-post .wpml-ls a").removeAttr("href");
  }

  function show_leaderboard(timeout) {
    setTimeout(() => {
      if ($(".header-ad>div>div").contents().length > 0) {
        $(".header-ad").removeClass("hidden");
        return true;
      } else {
        return false;
      }
    }, timeout);
  }

  $(window).on("load", () => {
    (function () {
      if (show_leaderboard(1000)) return;
      if (show_leaderboard(2000)) return;
      if (show_leaderboard(3000)) return;
      if (show_leaderboard(4000)) return;
      if (show_leaderboard(5000)) return;
    })();

    setTimeout(() => {
      $(".lazy").each(function () {
        var image = $(this);
        var background = image.data("background");
        image.css("background-image", `url("${background}")`);
        image.removeAttr("data-background");
      });
    }, 1200);
  });
});
